import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';

const PILLAR_SCALE_MAX = 6;

export interface Props {
  label: string;
  score: number;
  color: string;
}

export const WorkforceCulturalPillarScoreRow = ({label, score, color}: Props) => {
  const barWidth = Math.min(100, Math.max(0, (score / PILLAR_SCALE_MAX) * 100));
  const displayValue = score.toFixed(1);

  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 1}}>
      <Typography sx={{fontSize: 12, color: 'text.secondary', minWidth: 60}}>
        {label}
      </Typography>
      <Box
        sx={{
          flex: 1,
          height: 5,
          bgcolor: orangeColors[5],
          borderRadius: '3px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: `${barWidth}%`,
            borderRadius: '3px',
            bgcolor: color,
            transition: 'width 0.7s cubic-bezier(.4,0,.2,1)',
          }}
        />
      </Box>
      <Typography sx={{fontSize: 12, fontWeight: 500, color, minWidth: 28, textAlign: 'right'}}>
        {displayValue}
      </Typography>
    </Box>
  );
};
